import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import FileRepositoryTree from './FileRepositoryTree';
import FileRepositoryTreeService from '../services/FileRepositoryTreeService';
import FileRepositoryCategoryService from '../services/FileRepositoryCategoryService';
import FileRepositoryFileService from '../services/FileRepositoryFileService';
import FileRepositoryLinkService from '../services/FileRepositoryLinkService';

class FileRepositoryTreeContainer extends Component {
  componentDidMount() {
    FileRepositoryTreeService.init();
    FileRepositoryFileService.init();
    FileRepositoryLinkService.init();
    FileRepositoryCategoryService.init();
  }

  render() {
    return (
      <FileRepositoryTree
        attachmentRepositories={toJS(FileRepositoryTreeService.attachmentRepositories)}
        fetching={FileRepositoryTreeService.fetch.fetching}
        onDeleteCategory={FileRepositoryCategoryService.handleRemove}
        onDeleteAttachment={FileRepositoryFileService.handleRemove}
        onAddFile={FileRepositoryFileService.handleToggleModal}
        onAddLink={FileRepositoryLinkService.handleToggleModal}
        onAddSubcategory={FileRepositoryCategoryService.handleToggleCategoryModal}
        onSetIsEditing={FileRepositoryCategoryService.handleSetIsEditing}
        isEditing={FileRepositoryCategoryService.isEditing}
      />
    );
  }
}

export default observer(FileRepositoryTreeContainer);
